import { render, staticRenderFns } from "./DamagedAssetCardComponent.vue?vue&type=template&id=2594f4a3"
import script from "./DamagedAssetCardComponent.vue?vue&type=script&lang=js"
export * from "./DamagedAssetCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports